import React from 'react'
import reactStamp from 'react-stamp'
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import './appointments.css'
import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';
import moment from 'moment';
import Snackbar from 'material-ui/Snackbar';
import FreeSlots from './FreeSlots'

export default reactStamp(React).compose({

    init(){
        this.handleBook = this.handleBook.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.getSlotsForDate = this.getSlotsForDate.bind(this);
        this.handleSlotChange = this.handleSlotChange.bind(this);
        this.handleBook = this.handleBook.bind(this);
        this.success = this.success.bind(this);
        this.handleRequestClose = this.handleRequestClose.bind(this);
        this.getCalendarContent = this.getCalendarContent.bind(this);
    },

    state: {
        selectedPractitioner: "",
        selectedSlot: "",
        selectedSchedule: "",
        open: false
    },

    handleChange(event, id, value){
        this.setState({selectedPractitioner: value, slots: undefined});
        this.props.handleProviderSelect(value);
    },

    onSelect(e){
        this.setState({selectedSlot: "", selectedSchedule: "", slots: undefined}, () => {
            this.getSlotsForDate(e.format('YYYY-MM-DD'));
        })
    },

    render(){
        const items = this.getPractitionersMenuItems(this.props.practitioners);



        let calWidth;
        let flex;
        if (this.props.single) {
            calWidth = 250;
        } else {
            calWidth = 350;
            flex = "flex-container"
        }

        const styles = {
            button: {
                height: 50,
                width: 220,
                marginRight: 10,
                marginLeft: 10,
            }
        };

        return (
            <div className="booking-container">
                <div className="booking-head">
                    <h1 className="booking-title">Booking an Appointment</h1>
                </div>

                <div className={"schedule-with-container "+flex}>
                    <p>Schedule an appointment with:</p>
                    <div className="providers-select-field">
                        <SelectField value={this.state.selectedPractitioner} onChange={this.handleChange}>
                            {items}
                        </SelectField>
                    </div>
                </div>

                {
                    this.getCalendarContent(calWidth)
                }

                <FreeSlots
                    slots={this.state.slots}
                    handleSlotChange={this.handleSlotChange}
                />
                {
                    this.state.selectedSlot != "" ?
                        <div className="footer-actions">
                            <RaisedButton
                                label="Cancel"
                                style={styles.button}
                                onTouchTap={this.handleCancelClick}
                            />
                            <RaisedButton
                                label="Book Appointment"
                                primary={true}
                                style={styles.button}
                                onTouchTap={this.handleBook}
                            />
                        </div> : null
                }

                <Snackbar
                    open={this.state.open}
                    message="Successfuly booked !"
                    autoHideDuration={3000}
                    onRequestClose={this.handleRequestClose}
                />

            </div>
        )

    },

    getCalendarContent(calWidth){
        let today = new Date();
        let maxDate = this.findMaxDate();
        let disabledDates = this.getDisabledDates();
        let disabledDatesStrings = [];
        for (let dateIndex in disabledDates) {
            disabledDatesStrings.push(disabledDates[dateIndex]._d)
        }

        if (this.state.selectedPractitioner != "") {
            if (disabledDatesStrings.length > 0) {
                return <div>
                    <p>Choose available date and Time </p>

                    <InfiniteCalendar
                        theme={
                                    {
                                        selectionColor: '#0ca0d0',
                                        textColor: {
                                            default: '#333',
                                            active: '#FFF'
                                        },
                                        weekdayColor: '#CCCCCC',
                                        headerColor: '#BABABA',
                                        floatingNav: {
                                            background: '#CCCCCC',
                                            color: '#FFF',
                                            chevron: '#FFF'
                                        }
                                    }
                                }
                        width={calWidth}
                        height={300}
                        maxDate={maxDate}
                        minDate={today}
                        keyboardSupport={true}
                        onSelect={this.onSelect}
                        disabledDates={disabledDatesStrings}
                    />
                </div>
            } else {
                return <p>
                    There are no available days with free slots.
                </p>
            }
        } else {
            return null;
        }
    },

    handleCancelClick(){
        this.props.activateHistory();
    },

    getPractitionersMenuItems(practitioners){
        let items = [];
        for (let practitioner in practitioners) {
            items.push(
                <MenuItem
                    key={practitioner}
                    value={practitioners[practitioner].id}
                    primaryText={practitioners[practitioner].name.given+" "+practitioners[practitioner].name.family}
                />
            )
        }

        return items;
    },

    getSlotsForDate(date){
        for (let dateIndex in this.props.daysWithFreeSlots.datesWithFreeSlots) {
            if (this.props.daysWithFreeSlots.datesWithFreeSlots[dateIndex].date == date) {
                this.setState({slots: this.props.daysWithFreeSlots.datesWithFreeSlots[dateIndex].slots})
            }
        }
    },

    findMaxDate(){
        let dates = [];
        if (this.props.daysWithFreeSlots == undefined) {
            return "";
        } else {
            for (let dateIndex in this.props.daysWithFreeSlots.datesWithFreeSlots) {
                dates.push(moment(this.props.daysWithFreeSlots.datesWithFreeSlots[dateIndex].date));
            }
            dates.sort((a, b)=> {
                return b.isAfter(a)
            });
            return dates.length != 0 ?  dates[0]._i : undefined ;
        }
    },

    getDisabledDates(){
        let disabledDates = [];
        let dates = [];
        if (this.props.daysWithFreeSlots == undefined) {
            return "";
        } else {
            for (let dateIndex in this.props.daysWithFreeSlots.datesWithFreeSlots) {
                dates.push(moment(this.props.daysWithFreeSlots.datesWithFreeSlots[dateIndex].date));
            }
            dates.sort((a, b)=> {
                return b.isAfter(a);
            });
            disabledDates = this.getDates(moment(Date.now()), dates[0]);
            for (let dateIndex in dates) {
                for (let dateDIndex in disabledDates) {
                    if (dates[dateIndex].startOf('day').isSame(disabledDates[dateDIndex].startOf('day'))) {
                        disabledDates.splice(dateDIndex, 1);
                    }
                }
            }
            return disabledDates;
        }


    },

    getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = startDate;
        while (currentDate <= stopDate) {
            dateArray.push(currentDate)
            currentDate = moment(currentDate).add(1, 'days');
        }
        return dateArray;
    },


    handleSlotChange(id){
        this.setState({selectedSlot: id.split("/")[0], selectedSchedule: id.split("/")[1]})
    },

    handleBook(){
        let data = {};
        data.practitionerID = this.state.selectedPractitioner;
        data.scheduleID = this.state.selectedSchedule;
        data.slotID = this.state.selectedSlot;
        this.props.putSchedule(data, this.success);
    },

    success(){
        this.setState({
            open: true,
        });
    },

    handleRequestClose(){
        this.setState({
            open: false,
        });
        this.props.activateHistory();
    }


});


/** WEBPACK FOOTER **
 ** ./src/app/components/Appointments/AppointmentsBooking.js
 **/